<template>

    <FloatingPanel ref="floatingPanel" :title="title" :width="calculatedWidth">

        <div class="canvas::editor-website-editors-loop-LoopItemPanel">

            <slot/>

        </div>

        <template v-slot:actions>

            <slot name="actions">
                <div :class="actionsClass || 'defaultActions flex'">

                    <slot name="actionsExtra"></slot>

                    <!-- TODO Low: Move to LoopPanel? -->
                    <button
                        class="btn btn-blue"
                        @click="startMoving"
                    >
                        <i class="mr-1 fa fa-arrows-alt"></i> Verplaats
                    </button>

                     <button
                         class="btn btn-red"
                         @click="removeItem"
                     >
                        <i class="mr-1 fa fa-trash"></i> Verwijder
                    </button>
                </div>
            </slot>

        </template>

    </FloatingPanel>

</template>

<script>

import Swal from 'sweetalert2';

import AbstractPanel from "../AbstractPanel";
import FloatingPanel from "../panels/FloatingPanel";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
    },

    props: {
        title: {
            type: String,
            default()
            {
                // @ugly Getting the editor this way and get the label.
                return this.$parent.selection.currentSelection.editableData?.label || 'Loop item';
            },
        },
        width: Number,
    },

    data() {
        return {
            hasSlots: Object.keys(this.$slots).length,
            hasActionSlot: 'actions' in this.$slots,
            actionsClass: null
        }
    },

    created()
    {
        if( !Object.keys(this.$slots).length ) {
            this.actionsClass = 'flex flex-col gap-4 p-5';
        }
    },

    methods: {

        // Todo: implement?
        // duplicateLoopItem() {
        //     // console.log(this.loopItems, this.loopIndex, this.loopItems[this.loopIndex])
        //     console.log(this.loopItems[this.loopIndex], this.loopIndex, this.loopItems);
        //     // this.loopItems.push(this.loopItems[this.loopIndex]);
        //
        //     // // Set on canvas block which will invalidate.
        //     // this.canvasBlock.options.loops[this.loopKey].items = this.loopItems;
        //
        //     // Deselect
        //     this.pageComponent.selection.setSelection(null);
        // },

        async removeItem()
        {
            // Abort due to user does not confirm?
            const {value: confirmed} = await Swal.fire({
                title: 'Weet u het zeker?',
                text: 'Weet u zeker dat u deze wenst te verwijderen?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, verwijder',
                confirmButtonColor: '#f87171',
                cancelButtonText: 'Annuleer',
                willOpen: () => {
                    let fromTop = this.editorComponent.element.get(0).getBoundingClientRect().top;
                    
                    // Check if element will be out of view.
                    let swalHeight = $(Swal.getPopup()).height();
                    if (fromTop + swalHeight > window.innerHeight) {
                        fromTop = window.innerHeight - swalHeight - 20;
                    }

                    Swal.getPopup().style.position = 'fixed';
                    Swal.getPopup().style.display = 'block';
                    Swal.getPopup().style.top = fromTop + 'px';
                },
            });

            if (!confirmed)
                return;

            // Set on canvas block which will invalidate.
            this.removeFromLoopItems();
            this.removeFromBlocks();

            // Deselect
            this.pageComponent.selection.setSelection(null);
        },

        removeFromLoopItems()
        {
            // Remove from loop items.
            this.loopItems.splice(this.loopIndex, 1);

            this.canvasBlock.options.loops[this.loopKey].items = this.loopItems;

            // Remove nested loops.
            for(let key of Object.keys(this.canvasBlock.options.loops)) {
                if (key.startsWith(this.loopKey + '.' + this.loopIndex + '.'))
                    this.$delete(this.canvasBlock.options.loops, key);
            }
        },

        removeFromBlocks()
        {
            let oldCanvasBlockLoops = {...this.canvasBlock.options.loops};
            let oldLoopKey = this.loopKey;

            // Remove underlying canvas blocks.
            for (let childCanvasBlock of Object.values(this.canvasBlock.children)) {

                // Get fresh index, since object may be mutated (delete some, down here).
                let childCanvasBlockIndex = Object.values(this.canvasBlock.children).indexOf(childCanvasBlock);

                // Delete due to not a block of this loop item?
                if (childCanvasBlock.key.startsWith(this.loopKey + '.' + this.loopIndex + '.')) {
                    this.$delete(this.canvasBlock.children, childCanvasBlockIndex);
                }
            }

            //
            let adjustedLoops = [];

            // Now the unused blocks are removed, move down blocks after this block to fill the gap.
            for (let childCanvasBlock of Object.values(this.canvasBlock.children)) {

                if(!childCanvasBlock.key.startsWith(this.loopKey + '.'))
                    continue;

                // Get item index.
                let itemIndex = parseInt(childCanvasBlock.key.substring(this.loopKey.length).split('.')[1].split('.')[0]);

                //console.info({itemIndex, loopIndex: this.loopIndex})

                // Lower key, move it back?
                if (itemIndex > this.loopIndex && childCanvasBlock.key.startsWith(this.loopKey + '.')) {

                    // Lower index in key.
                    let keySuffix = childCanvasBlock.key.substring(this.loopKey.length).split('.').slice(2).join('.');
                    let newKey = this.loopKey + '.' + (itemIndex - 1) + '.' + keySuffix;

                    // Set new key.
                    this.$set(childCanvasBlock, 'key', newKey);

                    // Set in (nested) loops.
                    this.moveLoopIndices(itemIndex, adjustedLoops, oldCanvasBlockLoops);

                    // Trigger reactivity.
                    this.canvasBlock.options.loops = {...this.canvasBlock.options.loops};
                }
            }
        },

        // @ugly Made with little time. We first tweak canvas block indices, then the loops. Should be the other way around.
        moveLoopIndices(itemIndex, adjustedLoops, oldCanvasBlockLoops)
        {
            // Set in nested loops.
            for(let key of Object.keys(oldCanvasBlockLoops)) {
                let oldLoopKey = key.substring(0, this.loopKey.length);

                /*console.info({
                    key,
                    oldLoopKey,
                    keySuffix,
                    startsWith: oldLoopKey + '.' + itemIndex + '.',
                    newKey,
                })*/

                if (this.canvasBlock.options.loops[oldLoopKey] && key.startsWith(oldLoopKey + '.' + itemIndex + '.')) {

                    if(!adjustedLoops.includes(key)) {
                        delete this.canvasBlock.options.loops[key];

                        adjustedLoops.push(key);
                    }

                    let keySuffix2 = key.split('.').slice(oldLoopKey.split('.').length + 1).join('.');
                    let newLoopKey = oldLoopKey + '.' + (itemIndex - 1) + '.' + keySuffix2;

                    /*console.info('adjust', {
                        key,
                        keySuffix2,
                        newLoopJeyPieces: [oldLoopKey, (itemIndex - 1), keySuffix2],
                        oldLoopKey, newLoopKey });*/

                    this.canvasBlock.options.loops[newLoopKey] = oldCanvasBlockLoops[key];
                }
            }
        },

        startMoving()
        {
            // Delegate
            this.loopEditorComponent.startMoving();
        },


    },

    computed: {

        loopKey()
        {
            return this.loopEditorComponent.loopKey;
        },

        loopIndex()
        {
            return this.loopItemEditorComponent.loopIndex;
        },

        loopItems()
        {
            return this.options.loops[this.loopKey].items;
        },

        loopItem()
        {
            return this.loopItems[this.loopIndex];
        },

        originalLoopItem()
        {
            return this.loopItemEditorComponent.loopItem;
        },

        loopItemEditorComponent()
        {
            return this.editorComponent;
        },

        loopEditorComponent()
        {
            return this.editorComponent.loopEditorComponent;
        },

        calculatedWidth()
        {
            // We have a max so move + delete + save will fit next to each other.
            return Math.max(this.width || 0, Object.keys(this.$slots).length ? 450 : 250);
        },

        /*
        editorComponent()
        {
            return this.pageComponent.selection.currentSelection;
        },
        */

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-website-editors-loop-LoopItemPanel {

    .actions:first-child {
        @apply pt-3;
    }

}

</style>
